import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { IconExternalLink } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi, postApi } from '../../api/call.api'
import { CARDS_PREVIEW } from '../../api/static.data.pnp'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import Layout from '../../layout/Layout'
import BlockListCard from './Components/Blocks/BlockListCard'
import CardDesignTab from './Components/CardDesignTab'
import CardPreview from './Components/PageTemplates/CardPreview'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const DigitalCardBuilder = () => {

    const { cardId } = useParams();

    const [designTab, setDesignTab] = useState(1);
    const [blocksData, setBlocksData] = useState([]);
    const [pageData, setPageData] = useState({
        backgroundOption: { gradientAngle: 'to bottom' },
        headerOption: { gradientAngle: 'to bottom' },
        textOption: {},
        layout: 1,
        socialLinks: [],
        socialLinksOption: { color: 'original', placement: 'top' },
        blocksOption: {
            titleColor: '#000000',
            descriptionColor: '#000000',
        }
    });
    const [pageName, setPageName] = useState(null);
    const [linkId, setLinkId] = useState(null)
    const mouseSensor = useSensor(MouseSensor)
    const touchSensor = useSensor(TouchSensor)
    const keyboardSensor = useSensor(KeyboardSensor)

    const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor);

    async function handleDragEnd(event) {
        const { active, over } = event;
        if (over && active?.id !== over?.id) {
            let local = [...blocksData];
            const activeIndex = local.findIndex(item => item.order === active.id);
            const overIndex = local.findIndex(item => item.order === over.id);
            let newArr = arrayMove(local, activeIndex, overIndex);
            setBlocksData(newArr);
            let postData = newArr.map((item, i) => {
                return {
                    blockType: item.blockType,
                    order: i + 1
                }
            })
            let resp = await postApi(postData, urlApi.changePositionOfCardBlocks + cardId);
            if (resp.responseCode === 500) {
                toast.error(resp.message);
            }
        }
    }

    async function getPageDetail() {
        let resp = await getApi(urlApi.getBusinessCardDetailsById + cardId);
        if (resp.responseCode === 200) {
            setLinkId(resp.data?.linkId);
            setPageName(resp?.data?.linkCode)
            setPageData(resp.data?.businessCardJson?.businessCardDesign);
            setBlocksData(resp.data?.businessCardJson?.blocksData);
        } else {
            toast.error(resp.message);
        }
    }

    async function publishPage() {
        let resp = await getApi(urlApi.publishBusinessCard + cardId);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getPageDetail();
    }, [cardId]);

    return (
        <Layout>
            <div className="text-center flex flex-wrap justify-center !gap-3 md:justify-between fixed bg-white w-[calc(100%-48px)] md:w-[calc(100%-300px)] top-[48px] pb-2 rounded-b-lg shadow-md px-3 z-30">
                {<div className='w-9'></div>}
                <div className="flex items-center justify-center gap-4 border-2 w-max mx-auto px-2 py-1.5 rounded-lg">
                    <button onClick={() => setDesignTab(1)} className={`text-sm font-bold !px-5 py-1 rounded-md ${designTab == 1 && 'bg-primary text-white'}`}>Build</button>
                    <button onClick={() => setDesignTab(2)} className={`text-sm font-bold !px-5 py-1 rounded-md ${designTab == 2 && 'bg-primary text-white'}`}>Design</button>
                </div>
                <div className="flex items-center gap-3">
                    <Link to={CARDS_PREVIEW + pageName} target='_blank'> <IconButton icon={<IconExternalLink size={20} />} /></Link>
                    {accessCheck(accessKeys?.publishBusinessCard) && <button className='primary-btn' onClick={() => publishPage()}>Publish Now</button>}
                </div>
            </div>
            <div className='mt-3 grid grid-cols-3 pt-[80px] md:pt-[40px]'>
                {
                    designTab === 1 ?
                        <div className='col-span-3 md:col-span-2'>
                            <div className='mt-2'>
                                {blocksData?.length > 0 ?
                                    <DndContext onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis]} collisionDetection={closestCenter} sensors={sensors}>
                                        <SortableContext items={blocksData?.map(item => item?.order)} strategy={verticalListSortingStrategy}>
                                            {
                                                blocksData?.map((block, index) => {
                                                    return (
                                                        <BlockListCard key={block?.order} blockData={block} callback={() => getPageDetail()} linkId={linkId} />
                                                    )
                                                })
                                            }
                                        </SortableContext>
                                    </DndContext>
                                    :
                                    (<div className='h-[40vh] flex items-center justify-center flex-col !p-10 text-center'>
                                        <p className='text-xl font-semibold'>Add links and fill those empty spaces</p>
                                        <p className='text-sm text-[var(--secondary-text)]'>Gather links from websites, social, videos, music... whatever <br /> you'd like! You'll create a cool, short page that can drive more <br />clicks, more views, and a wider audience.</p>
                                    </div>)
                                }
                            </div>
                        </div>
                        :
                        <CardDesignTab state={pageData} pageId={cardId} callback={() => getPageDetail()} />
                }
                <div className="col-span-3 md:col-span-1 w-full">
                    <div className='max-w-[360px] mx-auto w-full static md:fixed ms-3'>
                        <CardPreview blocksData={blocksData?.filter(item => item?.status == 1)} pageData={pageData} />
                        <p className="text-xs mt-3">*Publish Your business card for see the latest changes.</p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default DigitalCardBuilder